<script setup>
const props = defineProps(['items'])
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import BlogCard from './BlogCard.vue';
const slider_options = {
    rewind : true,
    width  : '100%',
    perPage: 4,
    gap    : '1rem',
    breakpoints: {
        640: {
            perPage: 1,
        },
        900: {
            perPage: 2,
        },
        1200: {
            perPage: 3,
        },
    }
}
</script>
<template lang="">
    <div>
        <splide :options="slider_options" class="w-full">
            <splide-slide v-for="item in items" :key="item.index">
                <BlogCard :item="item" />
            </splide-slide>
        </splide>
    </div>
</template>
